import { useSession } from "./session.store.js";

/** Qui est connecte, et de quoi partir. */
export function Compte(): JSX.Element {
  const utilisateur = useSession((magasin) => magasin.utilisateur);
  const deconnecter = useSession((magasin) => magasin.deconnecter);
  return (
    <div className="compte">
      <span title={utilisateur?.role}>{utilisateur?.login}</span>
      {/* Un mot plutot qu'un pictogramme : U+23FB n'a pas de glyphe dans
          beaucoup de polices systeme et sort en carre vide. */}
      <button type="button" className="quitter" onClick={() => void deconnecter()}>
        quitter
      </button>
    </div>
  );
}
